import { useState, useRef, useEffect, forwardRef } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import RcmpArrowDownThin from "../../../assets/icons/ArrowDownThin"
import useClickOutside from "../../../hooks/useClickOutside"
import { cStatusSlug } from "../../../constans/activity-slugs"

function RcmpOptions(props) {
  const {
    fnOnClickOption,
    aPosition,
    aOptions,
    fnCloseOptions,
    oData,
    nActivityId,
    columnId,
    cFieldSlug,
    setSelect,
    fnSetColorSelection,
    ...rest
  } = props
  const containerRef = useRef(null)
  useClickOutside(containerRef, () => fnCloseOptions())

  function fnHandleOnClick(e, data) {
    e.stopPropagation()
    fnOnClickOption(data)
    fnSetColorSelection(data.opfs_coption_color)
    return
  }

  if (!aPosition) return null
  return (
    <div
      ref={containerRef}
      className={styles.options}
      style={{ top: aPosition[0].top - 4, left: aPosition[0].left - 15 }}
      {...rest}
    >
      {aOptions.map((option, i) => {
        return (
          <div
            className={styles.option}
            onClick={(e) =>
              fnHandleOnClick(e, {
                opfs_coption_name: option?.opfs_coption_name,
                opfs_coption_color: option?.opfs_coption_color,
                opfv_opfs_nid: option?.opfs_nid,
              })
            }
            key={i}
          >
            {cFieldSlug === cStatusSlug ? (
              <Typography color={option?.opfs_coption_color} textAlign="left" type="p3">
                {option?.opfs_coption_name === "Done"
                  ? intl.get("ActivityStatus.done")
                  : intl.get("ActivityStatus.pending")}
              </Typography>
            ) : (

              <Typography color={option?.opfs_coption_color} textAlign="left" type="p3">
                  {option?.opfs_coption_name}
                </Typography>
            )}
          </div>
        )
      })}
    </div>
  )
}

export const RcmpSelectActivityRow = forwardRef((props, ref) => {
  const {
    onChange,
    fnSetNIdEnabled,
    cFieldSlug,
    selected,
    onClick,
    columnId,
    aAllFields,
    oBlock,
    nActivityId,
    fieldColor,
    bCanChange,
    ...rest
  } = props
  const [select, setSelect] = useState({})
  const [bIsOpen, setBIsOpen] = useState(false)
  const [oOptions, fnSetOOptions] = useState([])
  const [oPosition, fnSetOPosition] = useState({})
  const [aPositionOptionsCard, fnSetAPositionOptinosCard] = useState([])
  const [cColorSelection, fnSetColorSelection] = useState(fieldColor)
  const oData = oBlock.activities_pending ? oBlock.activities_pending : oBlock.activities

  useEffect(() => {
    var positionOptions = ref.current?.getClientRects()
    fnSetAPositionOptinosCard(positionOptions)
  }, [bIsOpen, oPosition])

  useEffect(() => {
    if (selected && cFieldSlug === cStatusSlug) {
      selected === "Concluida"
        ? setSelect({
            opfs_coption_name: intl.get("ActivityStatus.done"),
            opfs_coption_color: fieldColor,
          })
        : setSelect({
            opfs_coption_name: intl.get("ActivityStatus.pending"),
            opfs_coption_color: null,
          })
    } else {
      setSelect({ opfs_coption_name: selected, opfs_coption_color: fieldColor })
    }
  }, [])

  // if (!oData?.length) return null

  function fnHandleValue(data) {

    if (cFieldSlug === cStatusSlug) {
      const cNewValueStatus =
        data.opfs_coption_name === "Done"
          ? intl.get("ActivityStatus.done")
          : intl.get("ActivityStatus.pending")
      setSelect({ opfs_coption_name: cNewValueStatus })
      onChange?.(data)
      setBIsOpen(false)
      return
    }
    setSelect(data)
    onChange?.(data)
    setBIsOpen(false)
  }

  // function fnOpenOptions(e, id) {
  //   e.stopPropagation()
  //   setBIsOpen(prevIsOpen => !prevIsOpen)
  //   const options = aAllFields.find(field => field.opfd_nid == id)
  //   fnSetOOptions(options.options)
  // }
  function fnOpenOptions(e, id) {
    e.stopPropagation()
    setBIsOpen((prevIsOpen) => !prevIsOpen)
    const options = aAllFields.find((field) => field.opfd_nid == id)

    if (options.opfd_cslug === cStatusSlug) {
      return fnSetOOptions(options.options)
    }
    const activeOptions = options.options.filter((option) => option.op_panel_active)
    const selectedOption = options.options.filter(
      (option) => option.opfs_coption_name === selected,
    )
    !activeOptions.includes(selectedOption[0]) && activeOptions.push(selectedOption[0])
    fnSetOOptions(activeOptions)
  }
  function fnCloseOptions() {
    if (!bIsOpen) return
    setBIsOpen(false)
  }

  return (
    <div className={styles.selectContainer}>
      <div className={styles.selectContent} ref={ref}>
        <Typography textAlign="left" type="p4" color={cColorSelection}>
          {select?.opfs_coption_name || intl.get("select")}
        </Typography>
        {bCanChange && (
          <div
            className={styles.arrowContainer}
            onClick={(e) => fnOpenOptions(e, columnId)}
          >
            <RcmpArrowDownThin
              fill="#ACB4BA"
              style={{
                transform: bIsOpen && "rotate(-180deg)",
                transition: "all .2s",
              }}
            />
          </div>
        )}
      </div>
      {bIsOpen && (
        <RcmpOptions
          fnCloseOptions={fnCloseOptions}
          oData={oData}
          nActivityId={nActivityId}
          columnId={columnId}
          aOptions={oOptions}
          fnOnClickOption={fnHandleValue}
          aPosition={aPositionOptionsCard}
          cFieldSlug={cFieldSlug}
          setSelect={setSelect}
          fnSetColorSelection={fnSetColorSelection}
        />
      )}
    </div>
  )
})

export default RcmpSelectActivityRow
